import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, EditIcon, TrashIcon, AddIcon } from 'assets/icons';
import { StructureService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	city: '',
	since: '',
	until: '',
	country_id: ''
}

class Structures extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Ciudad',
			'Modalidad',
			'País',
			'Nº de participantes',
			'Monto del san',
			'Nº semanas, meses o quincenas',
			'Moneda',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		commission_percentage: 0,
		currencies: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Sanes Estructurados',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await StructureService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.sanes.rows,
			last_page: res.sanes.count,
			commission_percentage: res.commission_percentage || 0,
			currencies: res.currencies || []
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el SAN?',async () => {
			await StructureService.admin.delete({
				san_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el SAN correctamente");
			this.load(true);
		});
	}
	
	render() {
		const { visible } = this.state;
		const item: any = this.state.item;

		return (
			<div id="san-structures">
				<Modal
		          className="modal-create-san"
		          visible={ visible }
		          title={ `${ this.state.item != null ? 'Editar' : 'Creación de' } San Estructurado` }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	commission_percentage={ this.state.commission_percentage }
		          	item={ this.state.item }
		          	currencies={ this.state.currencies }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="row col-md-11">
								<div className="col-md">
									<Input
										value={ this.state.form.city }
										name="city"
										label="Ciudad"
										placeholder="Buscar"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md">
									<Select
										placeholder="Seleccionar"
										label="País"
										name="country_id"
										color="white"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.country_id }
										options={ [
											{ value: Constants.COUNTRIES.VZLA.toString() , label: 'Venezuela' },
											{ value: Constants.COUNTRIES.COL.toString() , label: 'Colombia' }
										] } />
								</div>
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Sanes Estructurados" data={ this.state.data.length } header={ this.state.header } titleRight={
					<>
						{
							checkPermission(Constants.MODULES.STRUCTURE,'write') && (
								<div className="container-add-table">
									<p>Nuevo</p>
									<button className="btn add-btn-table" onClick={ this.add }>
										<img src={ AddIcon } />
									</button>
								</div>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.city?.name || i.state?.name || '-' }</td>
								<td>{ i.modality?.name || '-' }</td>
								<td>{ i.country?.name || '-' }</td>
								<td>{ i.quantity_persons }</td>
								<td>{ Globals.formatMiles(i.amount,true,i.currency_symbol) }</td>
								<td>{ i.days_or_weeks } { i.frequency == Constants.FREQUENCIES.WEEK ? 'semana(s)' : i.frequency == Constants.FREQUENCIES.MONTH ? 'mes(es)' : 'quincena(s)' }</td>
								<td>{ i.currency?.name || '-' }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									{
										checkPermission(Constants.MODULES.STRUCTURE,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.STRUCTURE,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Structures);